import React, {useState} from "react";
import {Vacation, VacationRestControllerApiFactory} from "arteco-api-client-ts";
import {Alert, Button, Stack, Typography} from "@mui/material";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import {dateToString} from "../../../../components/utils/dates";
import {btnSx, fullName} from "../../../../components/kit";

import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import {Grid} from "@mui/material";
import FormAutocomplete from "../../../../components/form/form_inputs/form_autocomplete";
import {types} from "../../../../components/form/types";
import FormSelect from "../../../../components/form/form_inputs/form_select";
import {useForm, UseFormProps} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";

export const VacationEditPage = () => {
    const manager = useApiManager();
    const ctrl = manager.factory(VacationRestControllerApiFactory);
    const [loaded, setLoaded] = useState<Vacation>();

    const form = useForm({
        fetcher: (id) => ctrl.getVacation(id),
        updater: (bean) => ctrl.saveVacation(bean),
        remover: (id) => ctrl.deleteOrDismissVacation(id),
        postLoad: (bean) => setLoaded(bean),
        factory: () => {
            return {
                imputationYear: new Date().getFullYear(),
            } as Vacation;
        },
    } as UseFormProps<Vacation>);

    return (
        <>
            <FormContent form={form} title={"Ausencia"}>
                <FormAutocomplete field={"person"} label={"Persona"} type={types.people} />
                <FormInput field={"title"} type={"text"} label={"Título"} />

                <Grid container spacing={3}>
                    <Grid item xs={12} sm>
                        <FormInput field={"periodFrom"} type={"date"} label={"Desde"} />
                    </Grid>
                    <Grid item xs={12} sm>
                        <FormInput field={"periodTo"} type={"date"} label={"Hasta"} />
                    </Grid>
                    <Grid item xs={12} sm>
                        <FormInput
                            field={"imputationYear"}
                            type={"text"}
                            label={"Año de imputación"}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    <Grid item xs={12} sm>
                        <FormSelect field={"state"} label={"Estado"} type={types.vacationState}/>
                    </Grid>
                    <Grid item xs={12} sm>
                        <FormSelect field={"type"} label={"Tipo"} type={types.vacationType}/>
                    </Grid>
                    <Grid item xs={12} sm>
                        <FormAutocomplete field={"validator"} label={"Validador"} type={types.people}/>
                    </Grid>
                </Grid>

                {loaded?.id && <JustificationCheck vacation={loaded} onChange={setLoaded}/>}
            </FormContent>
        </>
    );
};

/**
 * Justificante visto por RR. HH. sin guardarlo (#13888): los que llevan diagnóstico no se suben, y esta
 * marca, con la fecha y quién lo vio, es la evidencia de la verificación. La pone el servidor.
 */
const JustificationCheck = ({vacation, onChange}: { vacation: Vacation, onChange: (v: Vacation) => void }) => {
    const manager = useApiManager();
    const ctrl = manager.factory(VacationRestControllerApiFactory);
    const [saving, setSaving] = useState(false);
    const checked = !!vacation.justificationCheckedDate;

    const toggle = () => {
        setSaving(true);
        manager.execute(ctrl.checkJustificationVacation(vacation.id!, !checked),
            checked ? "Marca de justificante quitada" : "Justificante marcado como visto")
            .then(onChange)
            .finally(() => setSaving(false));
    };

    return (
        <Alert severity={checked ? "success" : "info"} icon={<FactCheckOutlinedIcon/>} sx={{mt: 3}}
               action={<Button size="small" color="inherit" sx={btnSx} disabled={saving} onClick={toggle}>
                   {checked ? "Quitar la marca" : "Marcar como visto"}
               </Button>}>
            <Stack spacing={0.25}>
                <Typography variant="body2" fontWeight={600}>
                    {checked
                        ? `Justificante visto el ${dateToString(vacation.justificationCheckedDate)}`
                          + (vacation.justificationCheckedBy ? ` por ${fullName(vacation.justificationCheckedBy)}` : "")
                        : "Justificante sin verificar"}
                </Typography>
                <Typography variant="caption">
                    Si lleva diagnóstico, no lo guardes: míralo y márcalo aquí.
                </Typography>
            </Stack>
        </Alert>
    );
};
